"use client";

import { useState } from "react";


interface CommodityCategory {
  id: string;
  title: string;
  description: string;
  icon: string;
  products: {
    id: string;
    name: string;
    specs: string;
    origins: string;
    packaging: string;
  }[];
}

const CommodityAccordion = () => {
  const [activeCategory, setActiveCategory] = useState<string>("category_agricultural");

  const categories: CommodityCategory[] = [
    {
      id: "category_agricultural",
      title: "Agricultural Commodities",
      description: "Premium quality grains and feed ingredients from certified suppliers",
      icon: "SparklesIcon",
      products: [
        {
          id: "prod_soybean",
          name: "Soybean Meal",
          specs: "44-48% protein content, non-GMO available",
          origins: "USA, Brazil, Argentina",
          packaging: "Bulk or 50kg bags",
        },
        {
          id: "prod_corn",
          name: "Yellow Corn",
          specs: "Grade 2, max 14% moisture",
          origins: "USA, Ukraine, Brazil",
          packaging: "Bulk or containerized",
        },
        {
          id: "prod_wheat",
          name: "Hard Red Winter Wheat",
          specs: "12.5% protein minimum",
          origins: "USA, Canada, Russia",
          packaging: "Bulk shipments",
        },
        {
          id: "prod_rice",
          name: "Long Grain White Rice",
          specs: "5% broken, polished",
          origins: "India, Thailand, Vietnam",
          packaging: "25kg or 50kg bags",
        },
      ],
    },
    {
      id: "category_industrial",
      title: "Industrial Products",
      description: "Certified lubricants and industrial fluids for manufacturing",
      icon: "BeakerIcon",
      products: [
        {
          id: "prod_motor_oil",
          name: "Motor Oil",
          specs: "SAE 10W-40, API SN/CF",
          origins: "USA, UAE, Singapore",
          packaging: "208L drums or bulk",
        },
        {
          id: "prod_hydraulic",
          name: "Hydraulic Fluid",
          specs: "ISO VG 46, AW grade",
          origins: "USA, Germany",
          packaging: "20L pails or drums",
        },
        {
          id: "prod_grease",
          name: "Industrial Grease",
          specs: "NLGI Grade 2, lithium complex",
          origins: "USA, Japan",
          packaging: "16kg pails",
        },
      ],
    },
    {
      id: "category_construction",
      title: "Construction Materials",
      description: "High-strength cement for commercial and residential projects",
      icon: "BuildingOffice2Icon",
      products: [
        {
          id: "prod_portland",
          name: "Portland Cement (Type I)",
          specs: "42.5 MPa strength, ASTM C150",
          origins: "USA, Mexico, China",
          packaging: "50kg bags or bulk",
        },
        {
          id: "prod_rapid",
          name: "Rapid-Set Cement",
          specs: "52.5 MPa, early strength",
          origins: "USA, Germany",
          packaging: "25kg bags",
        },
        {
          id: "prod_white",
          name: "White Cement",
          specs: "Architectural grade, 52.5 MPa",
          origins: "Egypt, Turkey",
          packaging: "50kg bags",
        },
      ],
    },
  ];

  return (
    <></>
  );
};

export default CommodityAccordion;